<script>

export default {
    name: 'Menu'
}
</script>

<template>
    <div class="main">
        <div class="bloco1">
            <div class="logo">
                <img class="imagem" src="../assets/imagens/logo-completa.png" alt="">
                <p class="texto_titulo">Usinagem, Caldeiraria, Montagem e Manutenção Industrial.</p>
            </div>

            <div class="bloco2">
                <router-link class="item_menu" to="/">Home</router-link>
                <router-link class="item_menu" to="/sobre">Sobre</router-link>
                <router-link class="item_menu" to="/sede">Sede Fabril</router-link>
                <router-link class="item_menu" to="/servicos">Serviços</router-link>
                <router-link class="item_menu" to="/equipamentos">Equipamentos</router-link>
                <router-link class="item_menu" to="/qualidade">Qualidade</router-link>
                <router-link class="item_menu" to="/inspe">Inspeções</router-link>
                <router-link class="item_menu" to="/clientes">Clientes</router-link>
                <router-link class="item_menu" to="/contato">Contatos</router-link>
            </div>
            <nav class="nav">

                <a class="text_e_image" href="https://www.linkedin.com/company/nacional-industria-metal-rgica/">
                    <p class="textlinkedin">Conecte-se conosco no LinkedIn</p><img class="icone"
                        src="../assets/imagens/linkedin.png" v-show="true" alt="">
                </a>
            </nav>
            <router-view />
        </div>
    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
    .main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        background-color: #fff;
        height: 20vh;
        max-width: 100vw;
        border-bottom: 2px solid #0007662d;
    }

    .bloco1 {
        margin-top: 2%;
        margin-bottom: 1%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 0% 2%;
    }

    .bloco2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 0rem 0rem;
        background-color: #fff;
        z-index: 1;
    }

    .logo {

    }

    .nav {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 4rem;
        border-radius: 5px;
    }

    .titulo {
        font-size: 1rem;
        font-weight: bold;
        color: #444;
        width: auto;
    }
    .text_e_image {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        text-decoration: none;
        color: #444;

    }
    .item_menu {
        list-style-type: none;
        text-decoration: none;
        font-weight: 440;
        font-size: 0.55rem;
        color: #444;
        font-family: "Staatliches", sans-serif;
        letter-spacing: 0px;
        margin-top: 1rem;
        border-bottom: 3px solid #ffffff;
        padding-bottom: 0rem;
        width: 15%;
        text-align: center;
    }

    .item_menu:hover {
        border-bottom: 3px solid #444;
        transition: 1s;
    }

    .imagem {
        width: 20rem;
    }

    .icone {
        width: 1.5rem;
    }

    .texto_titulo {
        font-size: 0.65rem;
        letter-spacing: 0.8px;
    }

    .textlinkedin {
        width: 100%;
        font-size: 0.8rem;        
    }
}

@media (min-width: 901px) {
    .main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        background-color: #ffffff;
        height: 15vh;
        max-width: 100vw;
        border-bottom: 2px solid #0007662d;
    }

    .textlinkedin{
        font-size: 0rem;
    }
    .bloco1 {
        margin-top: 1%;
        margin-bottom: 1%;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0% 2%;
    }

    .bloco2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 0rem 5rem;
    }

    .logo {}

    .nav {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 3%;
        height: 4rem;
        border-radius: 5px;
    }

    .titulo {
        font-size: 1rem;
        font-weight: bold;
        color: #444;
        width: auto;
    }

    .item_menu {
        list-style-type: none;
        text-decoration: none;
        font-weight: 440;
        font-size: 0.9rem;
        color: #444;
        font-family: "Staatliches", sans-serif;
        letter-spacing: 1px;
        margin: 0rem 0rem;
        border-bottom: 3px solid #ffffff;
        padding-bottom: 0.3rem;
        width: 12%;
        text-align: center;
    }

    .item_menu:hover {
        border-bottom: 3px solid #444;
        transition: 1s;
    }

    .imagem {
        width: 15rem;
    }

    .icone {
        width: 1.5rem;
        margin: 0px 0.2rem;
    }

    .texto_titulo {
        font-size: 0.4rem;
        letter-spacing: 0.8px;

    }
}
</style>